import { render, staticRenderFns } from "./news.vue?vue&type=template&id=0c24a89e&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&lang=css&"
import style1 from "./news.vue?vue&type=style&index=1&id=0c24a89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c24a89e",
  null
  
)

export default component.exports